import { useState } from 'react';

import { Spinner } from '@blueprintjs/core';
import { Button, Tooltip } from '@opendoor/mosaic';
import { useIndxResults } from '@opendoor/tessellation';

import useMarkWorkOrderStarted from '../../../graphql/mutations/homework/useMarkWorkOrderStarted';
import useReIndexWorkOrder from '../../../graphql/mutations/indextrious/useReIndexWorkOrder';

interface Props {
  workOrderID: string;
}

const MarkWorkOrderStarted = (props: Props) => {
  const [markWorkOrderStarted] = useMarkWorkOrderStarted();
  const { refetch } = useIndxResults();

  const [reIndexWorkOrder] = useReIndexWorkOrder();

  const [loading, setLoading] = useState(false);

  const onMarkStarted = async () => {
    setLoading(true);
    try {
      const { errors } = await markWorkOrderStarted({
        variables: { workOrderID: props.workOrderID },
      });

      if (!errors) {
        await reIndexWorkOrder({ variables: { id: props.workOrderID } });
        refetch();
      }
    } catch (e: any) {}

    setLoading(false);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <Tooltip
      title="Starting project will mean that the work has started and the crew is deployed"
      aria-label="start-project"
      placement="top"
    >
      <Button onClick={onMarkStarted} variant="outlined" color="primary">
        Start Project
      </Button>
    </Tooltip>
  );
};

export default MarkWorkOrderStarted;
